import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
// import Header from "../../components/Header";
import { Link } from "react-router-dom";
import "./Profile.css";
import API from '../../Utils/Api';
import CustomLoader from "../../components/CustomLoader";
import { validateForm } from "../../Utils/validate";
import { gettoastsuccess, gettoastwarning } from "../../Utils/Common";
import { useAuth } from "../../hooks/useAuth";


const Profile = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showValidations, setShowValidations] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editModeChangePassword, setEditModeChangePassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [inputs, setInputs] = useState({ first_name: '', last_name: '' });
  const [inputscp, setInputsCp] = useState({ old_password: '', password: '', confirm_password: '' });
  const [errors, setErrors] = useState({});
  const [errorscp, setErrorsCp] = useState({});

const [coursehistory, setCoursehistory] = useState([]);
  

  // Validations
  const validations = {
    length: inputscp.password.length >= 8,
    number: /\d/.test(inputscp.password),
    upperLower: /[a-z]/.test(inputscp.password) && /[A-Z]/.test(inputscp.password),
    specialChar: /[^A-Za-z0-9]/.test(inputscp.password)
  };

  const handleInputChange = (event) => {
    setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
  }
  const handleInputChangeCp = (event) => {
    setInputsCp(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
  }

  // Helper: choose correct image
  const getIcon = (isValid) =>
    process.env.REACT_APP_BASE_URL +
    (isValid ? "assests/images/icon_valid.png" : "assests/images/icon_invalid.png");


  /* Update Profile */
  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log('inputs.accept_terms', inputs.accept_terms);

    const fields = [
      { field: 'first_name', label: 'First Name', rules: 'required', value: inputs.first_name },
      { field: 'last_name', label: 'Last Name', rules: 'required', value: inputs.last_name }
    ];
    console.log('fields', fields);
    const errors = validateForm(fields);
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
    } else {
      setErrors({});
      doUpdateProfile();
    }
  }
  const doUpdateProfile = async () => {
    setLoading(true);
    let error;
    try {
      const formInputs = { ...inputs }
      console.log('update_user_profile inputs', formInputs);
      API.post('update_user_profile', formInputs)
        .then(response => {
          setLoading(false);
          console.log('update_user_profile response', response.data);
          if (response.data.status === false) {
            gettoastwarning(response.data.message);
          } else {
            gettoastsuccess(response.data.message);
          }
        }).catch(e => {
          error = e.message;
          gettoastwarning(error);
        });
    } catch (e) {
      setLoading(false);
      error = e.message;
      gettoastwarning(error);
    }
  };
  /* Change Password */
  const handleChangePassword = async (event) => {
    event.preventDefault();
    console.log('inputs.accept_terms', inputs.accept_terms);

    const fields = [
      { field: 'old_password', label: 'Old Password', rules: 'required', value: inputscp.old_password },
      { field: 'password', label: 'Password', rules: 'required|strong_password', value: inputscp.password },
      { field: 'confirm_password', label: 'Confirm Password', rules: 'required|matches:password', value: inputscp.confirm_password },
    ];
    console.log('fields', fields);
    const errors = validateForm(fields);
    if (Object.keys(errors).length > 0) {
      setErrorsCp(errors);
    } else {
      setErrorsCp({});
      doChangePassword();
    }
  }
  const doChangePassword = async () => {
    setLoading(true);
    let error;
    try {
      const formInputs = { ...inputscp }
      console.log('update_user_profile inputs', formInputs);
      API.post('change_password', formInputs)
        .then(response => {
          setLoading(false);
          console.log('change_password response', response.data);
          if (response.data.status === false) {
            gettoastwarning(response.data.message);
          } else {
            gettoastsuccess(response.data.message);
          }
        }).catch(e => {
          error = e.message;
          gettoastwarning(error);
        });
    } catch (e) {
      setLoading(false);
      error = e.message;
      gettoastwarning(error);
    }
  };
  useEffect(() => {
    document.title = `Profile | Your Friend My Friend`;
    document.getElementById('bodywrap').className = 'brand';
    const getUserData = async () => {
      API.get("get_user_detail")
        .then((response) => {
          setLoading(false);
          console.log('get_user_detail response:: ', response.data);
          if (response.data.status === true) {
            const apiData = response.data?.data || null;
            setInputs({ ...apiData })
          }
        })
        .catch((error) => {
          console.log('get_user_detail error:: ', error?.message);
        });
    }
    getUserData();

    API.post("get_master_class_order_history")
        .then((response) => {
          setLoading(false);
          
          if (response.data.status === true) {
            setCoursehistory(response.data.data);
          }
        })
        .catch((error) => {
          
        });

  }, []);

  const handleLogout = async () => {
    const isConfirm = window.confirm('Are you sure you want to logout?');
    if (isConfirm) {
      logout();
      navigate("/dating-masterclass/");
    }
  }


  return (
    <>
      {/* <Header /> */}
      <CustomLoader loading={loading} />
      <div className="container-fluid d-flex align-items-center justify-content-center min-vh-100 lo-oma position-relative">
        <div className="back-btn d-flex gap-1" onClick={() => navigate(-1)}>
          <img
            src={process.env.REACT_APP_BASE_URL + "assests/images/left-frame.png"}
            alt="back"
            className="img-fluid"
          />
          back
        </div>
        <div className="row w-100 my-5">
          <div className="col-md-8 col-lg-6 mx-auto accor om-pa pt-1">
            <div className="gar">My profile</div>
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  Personal information
                </Accordion.Header>
                <Accordion.Body>
                  <form method="post" onSubmit={handleSubmit} encType="multipart/form-data">
                    <div className="mb-3">
                      <label className="form-label">
                        First name*
                      </label>
                      <div className={`input-group ${errors.first_name ? 'form-error' : ''}`}>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="First Name"
                          disabled={!editMode}
                          value={inputs?.first_name}
                          name="first_name"
                          onChange={handleInputChange}
                        />
                        {!editMode && (
                          <span className="input-group-text" style={{ cursor: "pointer" }} onClick={() => setEditMode(true)}>
                            <img
                              src={
                                process.env.REACT_APP_BASE_URL +
                                "assests/images/pen-frame.png"
                              }
                              alt="toggle-visibility"
                              className="img-fluid input-icon"
                            />
                          </span>
                        )}
                      </div>
                      {errors.first_name && (
                        <p className="text-danger error-text">{errors.first_name}</p>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        Last Name*
                      </label>
                      <div className={`input-group ${errors.last_name ? 'form-error' : ''}`}>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Last Name"
                          disabled={!editMode}
                          value={inputs?.last_name}
                          name="last_name"
                          onChange={handleInputChange}
                        />
                        {!editMode && (
                          <span className="input-group-text" style={{ cursor: "pointer" }} onClick={() => setEditMode(true)}>
                            <img
                              src={
                                process.env.REACT_APP_BASE_URL +
                                "assests/images/pen-frame.png"
                              }
                              alt="toggle-visibility"
                              className="img-fluid input-icon"
                            />
                          </span>
                        )}
                      </div>
                      {errors.last_name && (
                        <p className="text-danger error-text">{errors.last_name}</p>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        Email*
                      </label>
                      <div className="input-group disabled">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="janedoe@example.com"
                          disabled={true}
                          value={inputs?.email}
                        />
                        {/* {!editMode && (
                          <span className="input-group-text" style={{ cursor: "pointer" }} onClick={() => setEditMode(true)}>
                            <img
                              src={
                                process.env.REACT_APP_BASE_URL +
                                "assests/images/pen-frame.png"
                              }
                              alt="toggle-visibility"
                              className="img-fluid input-icon"
                            />
                          </span>
                        )} */}
                      </div>
                    </div>
                    {(inputs.login_type !== 'google' && inputs.login_type !== 'facebook' && inputs.login_type !== 'apple') && (
                      <div className="mb-3">
                        <label className="form-label">
                          Phone Number
                        </label>
                        <div className="input-group disabled">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="+353 667 789 09"
                            disabled={true}
                            value={inputs?.mobile_number}
                          />
                          {/* {!editMode && (
                            <span className="input-group-text" style={{ cursor: "pointer" }} onClick={() => setEditMode(true)}>
                              <img
                                src={
                                  process.env.REACT_APP_BASE_URL +
                                  "assests/images/pen-frame.png"
                                }
                                alt="toggle-visibility"
                                className="img-fluid input-icon"
                              />
                            </span>
                          )} */}
                        </div>
                      </div>
                    )}
                    {editMode && (
                      <div className="d-grid mb-3 mt-3 text-center">
                        {/* <Link to="" className="logus-in text-decoration-none">confirm changes</Link> */}
                        <button className="logus-in" type="submit">
                          confirm changes
                        </button>
                      </div>
                    )}
                  </form>
                </Accordion.Body>
              </Accordion.Item>
              {(inputs.login_type !== 'google' && inputs.login_type !== 'facebook' && inputs.login_type !== 'apple') && (
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    Change Password
                  </Accordion.Header>
                  <Accordion.Body>
                    {!editModeChangePassword ? (
                      <div className="mb-3">
                        <label className="form-label">Password</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <img
                              src={process.env.REACT_APP_BASE_URL + "assests/images/icon_password.png"}
                              alt="password"
                              className="img-fluid input-icon"
                            />
                          </span>
                          <input
                            type="password"
                            className="form-control"
                            placeholder="*******"
                            disabled
                          />
                          {!editModeChangePassword && (
                            <span className="input-group-text" style={{ cursor: "pointer" }} onClick={() => setEditModeChangePassword(true)}>
                              <img
                                src={
                                  process.env.REACT_APP_BASE_URL +
                                  "assests/images/icon_edit.png"
                                }
                                alt="toggle-visibility"
                                className="img-fluid input-icon"
                              />
                            </span>
                          )}
                        </div>
                      </div>
                    ) : (
                      <>
                        <form method="post" onSubmit={handleChangePassword} encType="multipart/form-data">
                          <div className="mb-3">
                            <label className="form-label">
                              Old Password
                            </label>
                            <div className={`input-group editak ${errorscp.old_password ? 'form-error' : ''}`}>
                              <span className="input-group-text">
                                <img
                                  src={process.env.REACT_APP_BASE_URL + "assests/images/icon_password.png"}
                                  alt="password"
                                  className="img-fluid input-icon"
                                />
                              </span>
                              <input
                                type={showOldPassword ? "text" : "password"}
                                className="form-control"
                                placeholder="Old Password"
                                value={inputscp.old_password}
                                name="old_password"
                                onChange={(e) => {
                                  handleInputChangeCp(e);
                                  if (!showValidations) setShowValidations(true);
                                }}
                              />
                              <span className="input-group-text" style={{ cursor: "pointer" }} onClick={() => setShowOldPassword(!showOldPassword)}>
                                <img
                                  src={
                                    process.env.REACT_APP_BASE_URL +
                                    (showOldPassword
                                      ? "assests/images/icon_eye.png"
                                      : "assests/images/icon_eye_slash.png")
                                  }
                                  alt="toggle-visibility"
                                  className="img-fluid input-icon"
                                />
                              </span>
                            </div>
                            {errorscp.old_password && (
                              <p className="text-danger error-text">{errorscp.old_password}</p>
                            )}
                          </div>
                          <div className="mb-3">
                            <label className="form-label">
                              Password
                            </label>
                            <div className={`input-group editak ${errorscp.password ? 'form-error' : ''}`}>
                              <span className="input-group-text">
                                <img
                                  src={process.env.REACT_APP_BASE_URL + "assests/images/icon_password.png"}
                                  alt="password"
                                  className="img-fluid input-icon"
                                />
                              </span>
                              <input
                                type={showPassword ? "text" : "password"}
                                className="form-control"
                                placeholder="New Password"
                                value={inputscp.password}
                                name="password"
                                onChange={(e) => {
                                  handleInputChangeCp(e);
                                  if (!showValidations) setShowValidations(true);
                                }}
                              />
                              <span className="input-group-text" style={{ cursor: "pointer" }} onClick={() => setShowPassword(!showPassword)}>
                                <img
                                  src={
                                    process.env.REACT_APP_BASE_URL +
                                    (showPassword
                                      ? "assests/images/icon_eye.png"
                                      : "assests/images/icon_eye_slash.png")
                                  }
                                  alt="toggle-visibility"
                                  className="img-fluid input-icon"
                                />
                              </span>
                            </div>
                            {errorscp.password && (
                              <p className="text-danger error-text">{errorscp.password}</p>
                            )}
                            {showValidations && (
                              <div className="mt-2">
                                <div className="condtions-or d-flex align-items-start gap-2 mb-1 mt-1">
                                  <img src={getIcon(validations.length)} alt="condition" className="img-fluid validation-icon" />
                                  At least 8 characters
                                </div>
                                <div className="condtions-or d-flex align-items-start gap-2 mb-1">
                                  <img src={getIcon(validations.number)} alt="condition" className="img-fluid validation-icon" />
                                  At least 1 number
                                </div>
                                <div className="condtions-or d-flex align-items-start gap-2 mb-1">
                                  <img src={getIcon(validations.specialChar)} alt="condition" className="img-fluid validation-icon" />
                                  At least 1 special character
                                </div>
                                <div className="condtions-or d-flex align-items-start gap-2">
                                  <img src={getIcon(validations.upperLower)} alt="condition" className="img-fluid validation-icon" />
                                  Both upper and lower case letters
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="mb-4">
                            <label className="form-label">
                              Confirm password
                            </label>
                            <div className={`input-group editak ${errorscp.confirm_password ? 'form-error' : ''}`}>
                              <span className="input-group-text">
                                <img
                                  src={process.env.REACT_APP_BASE_URL + "assests/images/icon_password.png"}
                                  alt="password"
                                  className="img-fluid input-icon"
                                />
                              </span>
                              <input
                                type={showConfirmPassword ? "text" : "password"}
                                className="form-control"
                                placeholder="Confirm New Password"
                                value={inputscp.confirm_password}
                                name="confirm_password"
                                onChange={handleInputChangeCp}
                              />
                              <span className="input-group-text" style={{ cursor: "pointer" }} onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                <img
                                  src={
                                    process.env.REACT_APP_BASE_URL +
                                    (showConfirmPassword
                                      ? "assests/images/icon_eye.png"
                                      : "assests/images/icon_eye_slash.png")
                                  }
                                  alt="toggle-visibility"
                                  className="img-fluid input-icon"
                                />
                              </span>
                            </div>
                            {errorscp.confirm_password && (
                              <p className="text-danger error-text">{errorscp.confirm_password}</p>
                            )}
                          </div>

                          <div className="d-grid mb-3 mt-3 text-center">
                            {/* <Link to="/login" className="logus-in text-decoration-none">Change password</Link> */}
                            <button className="logus-in" type="submit">
                              Change password
                            </button>
                          </div>
                        </form>
                      </>
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              )}
              <Accordion.Item eventKey="2" className="hololast">
                <Accordion.Header>
                  My Masterclass
                </Accordion.Header>
                <Accordion.Body>
                  {coursehistory.length > 0 ? (
                  <>
                 {coursehistory.map((val, i) => (
                  <div className="purch-his mb-3">
                    <div className="fir-fra mb-2">
                      <div className="dat-ti">{val.date_time}</div>
                      <div className="dat-titlk">{val.course_name}</div>
                      <div className="d-flex align-items-center justify-content-between">
                        
                      </div>
                    </div>
                    <Link to={`/master-class-video/${val.course_id}`} className="sec-fra">
                      <div className="masterclass">watch masterclass</div>
                    </Link>
                  </div>
                  ))} 
                   </>
                 ) : (
                    <div className="purch-his mb-3">
                      <div className="fir-fra mb-2 mt-3">
                        <p className="text-center">No data found</p>
                      </div>
                    </div>
                 )}
                  {/*<div className="purch-his mb-3">
                    <div className="fir-fra mb-2">
                      <div className="dat-ti">October 10th 2025, <span>10:11 AM</span></div>
                      <div className="dat-titlk">Annie Lavin’s Full Dating Masterclass</div>
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="pra-in">$240</div>
                        <div className="pai-lab">Paid</div>
                      </div>
                    </div>
                    <Link to="" className="sec-fra">
                      <div className="masterclass">watch masterclass</div>
                    </Link>
                  </div>
                  <div className="purch-his mb-3">
                    <div className="fir-fra">
                      <div className="dat-ti">October 8th 2025, <span>10:11 AM</span></div>
                      <div className="dat-titlk">Dublin Speed Dating</div>
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="pra-in">$60</div>
                        <div className="pai-lab">Paid</div>
                      </div>
                    </div>
                  </div>
                  <div className="purch-his mb-3">
                    <div className="fir-fra">
                      <div className="dat-ti">September 12th 2025, <span>10:11 AM</span></div>
                      <div className="dat-titlk">Dublin Speed Dating</div>
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="pra-in">$45</div>
                        <div className="pai-lab red">Refunded</div>
                      </div>
                    </div>
                  </div>*/}
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <div className="mb-3 mt-4">
                            
              <button className="logus-in w-auto" type="button" onClick={handleLogout}>
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
